// const WebFont = global.WebFont; // this is loaded after, so, would be undefined at this point!

const FONTS = {
    "Architects Daughter":    "Architects+Daughter::latin",
    "Arimo":                  "Arimo:400,400italic,700,700italic:latin",
    "Chewy":                  "Chewy::latin",
    "Changa One":             "Changa+One:400,400italic:latin",
    //"Droid Serif":            "Droid+Serif:400,400italic,700,700italic:latin",
    "Indie Flower":           "Indie+Flower::latin",
    //"Josefin Slab":           "Josefin+Slab:400,400italic,700,700italic:latin",
    "Lato":                   "Lato:400italic,400,700,700italic:latin",
    //"Lora":                   "Lora:400italic,400,700,700italic:latin",
    //"Open Sans":              "Open+Sans:400,400italic,700,700italic:latin",
    //"Oswald":                 "Oswald:400,700:latin",
    "Patrick Hand":           "Patrick+Hand::latin",
    //"Playfair Display":       "Playfair+Display:400,400italic,700,700italic:latin",
    //"PT Serif":               "PT+Serif:400,400italic,700,700italic:latin",
    //"Roboto Condensed":       "Roboto+Condensed:400italic,400,700,700italic:latin",
    //"Roboto Mono":            "Roboto+Mono:400,400italic,700,700italic:latin"
};

export default class StyleFontUtil {
    GOOGLE_DEFAULT = "'Arimo', sans-serif";

    /**
     * 
     * @param fontName 
     * 
     * @returns 
     */
    private loadGoogleFont(fontName: string) {
        let ret = FONTS[fontName];
        if (!ret) {
            console.warn("Font [" + fontName + "] is not supported by eSpatial");
            ret = fontName.replace(" ", "+");
        }

        return ret;
    }

    /**
     * 
     * @param fonts 
     * 
     * @returns 
     */
    load(fonts: string | string[]) {
        //console.log("es.util.style.font.load", fonts);

        if (!fonts) {
            return;
        }

        if (!Array.isArray(fonts)) {
            fonts = [fonts];
        }

        const fontsToLoad =[];
        for (let i = 0; i < fonts.length; i++) {
            const fontName = this._stripFontFallback(fonts[i]);
            if (es.loadedFonts.indexOf(fontName) < 0) {
                fontsToLoad.push(this.loadGoogleFont(fontName));
                es.loadedFonts.push(fontName);
            }
        }

        if (fontsToLoad.length > 0) {
            WebFont.load({
                google: {
                    families: fontsToLoad
                }
            });
            // es.log.info("GoogleFont.js", "Fonts loaded:", es.loadedFonts, "Corresponding Google Font imports:", fontsToLoad);
        }
    }

    /**
     * Strip fallback from name e.g. "'Chewy'" -> "Chewy"
     */
    private _stripFontFallback(val: string): string {
        if (val && val.indexOf("'") > -1) {
            return val.split("'")[1];
        }

        return val;
    }
}
